<div class="card pt-0 min-h-8">
  <div class="card-body">
    <div class="d-flex align-items-center">
      @if (iconClass) {
        <div class="flex-shrink-0 me-3">
          <div class="avatar-sm">
            <span
              class="avatar-title rounded-circle"
              [ngClass]="[
                'bg-' + toneOrDefault + '-lighten',
                'text-' + toneOrDefault,
              ]"
            >
              <i class="font-24" [ngClass]="iconClass"></i>
            </span>
          </div>
        </div>
      }
      <div class="d-flex flex-column flex-grow-1">
        <h3 class="mt-0">{{ total }}</h3>
        <h5 class="text-muted fw-normal mb-0">{{ label }}</h5>
        @if (description) {
          <small
            class="mt-1"
            [ngClass]="descriptionTone ? 'text-' + descriptionTone : 'text-muted'"
          >
            {{ description }}
          </small>
        }
      </div>
    </div>
  </div>
</div>
